import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PickableProjectsDataGrid } from "src/components/views/erp/project/delivery/picking/PickableProjectsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/delivery/pickableProjects")({
	staticData: { title: i18n.t("pickable_projects"), legacyViewKey: "pickableProjectsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PickableProjectsDataGrid />;
}
